module.exports = __webpack_public_path__ + "static/media/developer-skills.6fae186f.svg";